import { useGetWireTransferSetupQuery } from '@/features/means-of-payments/api/useGetWireTransferSetupQuery.ts';
import { MakeDefaultButton } from '@/features/means-of-payments/MakeDefaultButton.tsx';
import { MeanOfPaymentDescription } from '@/features/means-of-payments/MeanOfPaymentDescription.tsx';
import {
  Alert,
  ensureSxObject,
  getMessageFromError,
  Loader,
  Typography,
} from '@arsnovasystems/ars-front-lib';
import { Box, SxProps, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const WireTransferCallout = ({
  displayOnly = false,
  sx,
}: {
  displayOnly?: boolean;
  sx?: SxProps<Theme>;
}) => {
  const { t } = useTranslation();
  const { data, error, isLoading } = useGetWireTransferSetupQuery();

  if (isLoading) {
    return <Loader />;
  }

  if (data === undefined) {
    return null;
  }

  return (
    <Box
      sx={(theme) => ({
        ...ensureSxObject(sx, theme),
      })}
    >
      <Alert severity={'info'}>
        {!displayOnly && (
          <>
            <Typography variant={'h4'}>{t('ik.bank.transfer')}</Typography>
            <Typography
              variant={'subtitle2'}
              sx={{ marginTop: 1 }}
            >
              {t('ik.meansOfPayments.funding.subheader')}
            </Typography>
          </>
        )}

        <Typography
          variant='body2'
          sx={{ marginBottom: 2 }}
        >
          {t('ik.meansOfPayments.funding.approved.message')}
        </Typography>

        <MeanOfPaymentDescription meanOfPayment={data} />

        {!displayOnly ?
          <Box sx={{ marginTop: 2 }}>
            <MakeDefaultButton data={data} />
          </Box>
        : null}
      </Alert>

      {error ?
        <Alert sx={{ marginTop: 2 }}>{getMessageFromError(error)}</Alert>
      : null}
    </Box>
  );
};
